// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__25qeu","container":"styles_container__1gQnU","title":"styles_title__1Jp5z","wrapper":"styles_wrapper__SRUna","answer":"styles_answer__2EIkp"};